<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <section class="bg-white py-24">
    <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center max-w-2xl mx-auto">
        <p class="text-sky-600 font-semibold text-sm uppercase tracking-widest">
          {{ t('participants_lp.how_it_works.label') }}
        </p>
        <h2 class="text-3xl md:text-4xl font-bold text-slate-900 mt-3">
          {{ t('participants_lp.how_it_works.heading') }}
        </h2>
      </div>

      <div class="mt-16 relative">
        <!-- Connector line (desktop) -->
        <div class="hidden md:block absolute top-10 left-1/6 right-1/6 h-0.5 bg-sky-100" aria-hidden="true"></div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div
            v-for="step in 3"
            :key="step"
            class="flex flex-col items-center text-center"
          >
            <div class="relative w-20 h-20 rounded-full bg-sky-600 text-white flex items-center justify-center text-2xl font-black shadow-lg shadow-sky-200 mb-6 z-10">
              {{ step }}
            </div>
            <h3 class="text-lg font-bold text-slate-900">{{ t(`participants_lp.how_it_works.step${step}_title`) }}</h3>
            <p class="text-slate-500 mt-2 leading-relaxed">{{ t(`participants_lp.how_it_works.step${step}_body`) }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
